import React, { useState } from 'react'
import data from './faqData';
import SingleQuestion from './SingleQuestion'

const FAQ = () => {

  const [questions, setQuestions] = useState(data);
  console.log(setQuestions)
  return (
    <div className='pt-40 mt-20 pb-20 faq-main'>
      <div>
        <h1 className="text-center text-[40px] pb-10 text-[#35332F] leading-[4rem]">Frequently Asked questions</h1>
      </div>
        <div className='w-4/6 m-auto faq-ques'>
          <div className='flex flex-wrap '>
            {questions.map((question) => {
              return <SingleQuestion key={question.id} {...question} />
            })};
          </div>
        </div>
    </div>
  )
}

export default FAQ